/**
 * 订单路由
 */
export default [
  {
    path: '/order',
    meta: {
      title: '提交订单',
      needLogin: true,
    },
    component: (resolve) => {
      require(['$views/order/index.vue'], resolve)
    }
  },
  {
    path: '/order/list',
    meta: {
      title: '我的订单',
      needLogin: true,
    },
    component: (resolve) => {
      require(['$views/order/orderList.vue'], resolve)
    }
  },
  {
    path: '/order/detail/:orderNo',
    meta: {
      title: '订单详情',
      needLogin: true,
    },
    component: (resolve) => {
      require(['$views/order/detail.vue'], resolve)
    }
  },
  {
    path: '/order/express',
    meta: {
      title: '物流详情',
      needLogin: true,
    },
    component: (resolve) => {
      require(['$views/order/express.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes/modules/order.js